module.exports = __webpack_public_path__ + "media/heresOne.16b61f45.mp3";